import { z } from "zod";

export const EtlErroredSchema = z.object({
	etl_errored: z.boolean(),
});

export type EtlErrored = z.infer<typeof EtlErroredSchema>;
